import React, { useRef } from 'react';
import cn from 'classnames';
import _ from 'lodash';

import { useAppDispatch, useOnClickOutside } from 'client/hooks';
import { setIsShowFooterPopUpOverlay } from 'client/redux/ui';

import Icon, { IconType } from '../Icon';

import css from './Hints.module.scss';

export interface HintItemType {
  icon?: IconType | '';
  title: string;
  text: string;
}

interface Props {
  className?: string;
  hintClassName?: string;
  hints: HintItemType[];
  next: number;
  handleClose: () => void;
}

const Hints: React.FC<Props> = (props) => {
  const { className = '', hintClassName = '', hints, next, handleClose } = props;
  const dispatch = useAppDispatch();
  const hintWrapperRef = useRef(null);

  const clickOutside = () => {
    dispatch(setIsShowFooterPopUpOverlay(false));
    handleClose();
  };

  useOnClickOutside<HTMLDivElement>(hintWrapperRef, clickOutside);

  const renderHint = (hint: HintItemType) => {
    return (
      <div className={cn(css.hint, hintClassName, !hint.icon && css.noIcon)}>
        <div className={css.closeButton} onClick={handleClose}>
          <Icon type="close" />
        </div>
        <div className={css.hintContent}>
          {hint.icon && <Icon type={hint.icon} className={css.icon} />}
          <div className={css.title}>{hint.title}</div>
          <div className={css.text} dangerouslySetInnerHTML={{ __html: hint.text }} />
        </div>
      </div>
    );
  };

  if (_.size(hints) === 0 || !hints[next]) {
    return null;
  }

  return (
    <div className={cn(css.hints, className)} ref={hintWrapperRef}>
      <div className={css.overlay} onClick={handleClose} />
      {renderHint(hints[next])}
    </div>
  );
};

export default Hints;
